import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

export const PricingRuleItem = styled.div`
  padding: 8px 0px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PricingRuleMessage = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: ${colors.text.primary};
  letter-spacing: 0%;
`;
